import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { getRateNameForCustomer } from 'anchor-shared/lib/service/pure-functions/get-vessel-rate-name';

@Component({
  selector: 'app-booking-details-dialog',
  templateUrl: './booking-details-dialog.component.html',
  styleUrls: ['./booking-details-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BookingDetailsDialogComponent implements OnInit {
  charter: Charter;
  payoutBreakdowns: Payout[];
  discounts: any[];
  type: DialogType;
  headers = { base_rate: 'Base price breakdown', discount: 'Discount' };
  target?: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<BookingDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.charter = this.data.charter;
    this.payoutBreakdowns = this.data.payoutBreakdowns;
    this.discounts = this.data.discounts;
    this.type = this.data.type;
    this.target = this.data.target;
  }

  ngOnInit(): void {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    const rect = this.target.nativeElement.getBoundingClientRect();
    const width = 350;
    matDialogConfig.position = {
      left: `${rect.left + (rect.right - rect.left) / 2 - width / 2}px`,
    };
    matDialogConfig.width = `${width}px`;
    this.dialogRef.updateSize(matDialogConfig.width, matDialogConfig.height);
    this.dialogRef.updatePosition(matDialogConfig.position);
  }

  initRates() {
    getRateNameForCustomer(this.charter.originalRates[0]);
  }

  calculateBaseRate(payouts) {
    return payouts.reduce((acc, curr) => acc + Number(curr.basePay || 0), 0);
  }

  calculateDiscount() {
    return this.discounts.reduce((acc, curr) => acc + curr.amount, 0);
  }

  close() {
    this.dialogRef.close();
  }
}

type DialogType = 'base_rate' | 'discount';
